"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7357],{

/***/ 27357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AnimatePresence": function() { return /* reexport */ AnimatePresence/* AnimatePresence */.M; },
  "AnimateSharedLayout": function() { return /* reexport */ AnimateSharedLayout; },
  "AnimationType": function() { return /* reexport */ types/* AnimationType */.r; },
  "DeprecatedLayoutGroupContext": function() { return /* reexport */ DeprecatedLayoutGroupContext; },
  "DragControls": function() { return /* reexport */ DragControls; },
  "FlatTree": function() { return /* reexport */ flat_tree/* FlatTree */.E; },
  "LayoutGroup": function() { return /* reexport */ LayoutGroup; },
  "LayoutGroupContext": function() { return /* reexport */ LayoutGroupContext/* LayoutGroupContext */.p; },
  "LazyMotion": function() { return /* reexport */ LazyMotion; },
  "MotionConfig": function() { return /* reexport */ MotionConfig; },
  "MotionConfigContext": function() { return /* reexport */ MotionConfigContext/* MotionConfigContext */._; },
  "MotionContext": function() { return /* reexport */ MotionContext/* MotionContext */.v; },
  "MotionValue": function() { return /* reexport */ es_value/* MotionValue */.H; },
  "PresenceContext": function() { return /* reexport */ PresenceContext/* PresenceContext */.O; },
  "Reorder": function() { return /* reexport */ Reorder; },
  "SwitchLayoutGroupContext": function() { return /* reexport */ SwitchLayoutGroupContext/* SwitchLayoutGroupContext */.g; },
  "addPointerEvent": function() { return /* reexport */ use_pointer_event/* addPointerEvent */.a; },
  "addScaleCorrector": function() { return /* reexport */ scale_correction/* addScaleCorrector */.B; },
  "animate": function() { return /* reexport */ animate/* animate */.j; },
  "animateVisualElement": function() { return /* reexport */ animation/* animateVisualElement */.d5; },
  "animationControls": function() { return /* reexport */ animationControls; },
  "animations": function() { return /* reexport */ animations/* animations */.s; },
  "calcLength": function() { return /* reexport */ delta_calc/* calcLength */.JO; },
  "checkTargetForNewValues": function() { return /* reexport */ setters/* checkTargetForNewValues */.GJ; },
  "createBox": function() { return /* reexport */ models/* createBox */.dO; },
  "createDomMotionComponent": function() { return /* reexport */ motion/* createDomMotionComponent */.F; },
  "createMotionComponent": function() { return /* reexport */ es_motion/* createMotionComponent */.F; },
  "domAnimation": function() { return /* reexport */ domAnimation; },
  "domMax": function() { return /* reexport */ domMax; },
  "filterProps": function() { return /* reexport */ filter_props/* filterProps */.L; },
  "isBrowser": function() { return /* reexport */ is_browser/* isBrowser */.j; },
  "isDragActive": function() { return /* reexport */ lock/* isDragActive */.gD; },
  "isMotionValue": function() { return /* reexport */ is_motion_value/* isMotionValue */.i; },
  "isValidMotionProp": function() { return /* reexport */ valid_prop/* isValidMotionProp */.Z; },
  "m": function() { return /* reexport */ m; },
  "makeUseVisualState": function() { return /* reexport */ use_visual_state/* makeUseVisualState */.t; },
  "motion": function() { return /* reexport */ motion/* motion */.E; },
  "motionValue": function() { return /* reexport */ es_value/* motionValue */.B; },
  "resolveMotionValue": function() { return /* reexport */ resolve_motion_value/* resolveMotionValue */.b; },
  "transform": function() { return /* reexport */ transform; },
  "useAnimation": function() { return /* reexport */ useAnimation; },
  "useAnimationControls": function() { return /* reexport */ useAnimationControls; },
  "useAnimationFrame": function() { return /* reexport */ useAnimationFrame; },
  "useCycle": function() { return /* reexport */ useCycle; },
  "useDeprecatedAnimatedState": function() { return /* reexport */ useAnimatedState; },
  "useDeprecatedInvertedScale": function() { return /* reexport */ useInvertedScale; },
  "useDomEvent": function() { return /* reexport */ use_dom_event/* useDomEvent */.p; },
  "useDragControls": function() { return /* reexport */ useDragControls; },
  "useElementScroll": function() { return /* reexport */ useElementScroll; },
  "useForceUpdate": function() { return /* reexport */ use_force_update/* useForceUpdate */.N; },
  "useInView": function() { return /* reexport */ useInView; },
  "useInstantLayoutTransition": function() { return /* reexport */ useInstantLayoutTransition; },
  "useInstantTransition": function() { return /* reexport */ useInstantTransition; },
  "useIsPresent": function() { return /* reexport */ use_presence/* useIsPresent */.hO; },
  "useIsomorphicLayoutEffect": function() { return /* reexport */ use_isomorphic_effect/* useIsomorphicLayoutEffect */.L; },
  "useMotionTemplate": function() { return /* reexport */ useMotionTemplate; },
  "useMotionValue": function() { return /* reexport */ useMotionValue; },
  "usePresence": function() { return /* reexport */ use_presence/* usePresence */.oO; },
  "useReducedMotion": function() { return /* reexport */ use_reduced_motion/* useReducedMotion */.J; },
  "useReducedMotionConfig": function() { return /* reexport */ use_reduced_motion/* useReducedMotionConfig */.h; },
  "useResetProjection": function() { return /* reexport */ useResetProjection; },
  "useScroll": function() { return /* reexport */ useScroll; },
  "useSpring": function() { return /* reexport */ useSpring; },
  "useTime": function() { return /* reexport */ useTime; },
  "useTransform": function() { return /* reexport */ useTransform; },
  "useUnmountEffect": function() { return /* reexport */ use_unmount_effect/* useUnmountEffect */.z; },
  "useVelocity": function() { return /* reexport */ useVelocity; },
  "useViewportScroll": function() { return /* reexport */ useViewportScroll; },
  "useVisualElementContext": function() { return /* reexport */ MotionContext/* useVisualElementContext */.B; },
  "visualElement": function() { return /* reexport */ render/* visualElement */.q; },
  "wrapHandler": function() { return /* reexport */ event_info/* wrapHandler */.q; }
});

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs
var motion = __webpack_require__(7312);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-proxy.mjs
var motion_proxy = __webpack_require__(39169);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/create-config.mjs + 7 modules
var create_config = __webpack_require__(8550);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs



/**
 * @public
 */
var m = (0,motion_proxy/* createMotionProxy */.D)(create_config/* createDomMotionConfig */.w);



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(95421);
// EXTERNAL MODULE: ./node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(24394);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(96681);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(25364);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/DeprecatedLayoutGroupContext.mjs


/**
 * @deprecated
 */
var DeprecatedLayoutGroupContext = (0,react.createContext)(null);



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-force-update.mjs
var use_force_update = __webpack_require__(43062);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/projection/node/group.mjs
var notify = function (node) {
    return !node.isLayoutDirty && node.willUpdate(false);
};
function nodeGroup() {
    var nodes = new Set();
    var subscriptions = new WeakMap();
    var dirtyAll = function () { return nodes.forEach(notify); };
    return {
        add: function (node) {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: function (node) {
            var _a;
            nodes.delete(node);
            (_a = subscriptions.get(node)) === null || _a === void 0 ? void 0 : _a();
            subscriptions.delete(node);
            dirtyAll();
        },
        dirty: dirtyAll,
    };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/LayoutGroup/index.mjs








var shouldInheritGroup = function (inherit) { return inherit === true; };
var shouldInheritId = function (inherit) {
    return shouldInheritGroup(inherit === true) || inherit === "id";
};
var LayoutGroup = function (_a) {
    var _b, _c;
    var children = _a.children, id = _a.id, inheritId = _a.inheritId, _d = _a.inherit, inherit = _d === void 0 ? true : _d;
    // Maintain backwards-compatibility with inheritId until 7.0
    if (inheritId !== undefined)
        inherit = inheritId;
    var layoutGroupContext = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p);
    var deprecatedLayoutGroupContext = (0,react.useContext)(DeprecatedLayoutGroupContext);
    var _e = (0,tslib_es6.__read)((0,use_force_update/* useForceUpdate */.N)(), 2), forceRender = _e[0], key = _e[1];
    var context = (0,react.useRef)(null);
    var upstreamId = (_b = layoutGroupContext.id) !== null && _b !== void 0 ? _b : deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) {
            id = id ? upstreamId + "-" + id : upstreamId;
        }
        context.current = {
            id: id,
            group: shouldInheritGroup(inherit)
                ? (_c = layoutGroupContext === null || layoutGroupContext === void 0 ? void 0 : layoutGroupContext.group) !== null && _c !== void 0 ? _c : nodeGroup()
                : nodeGroup(),
        };
    }
    var memoizedContext = (0,react.useMemo)(function () { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context.current), { forceRender: forceRender })); }, [key]);
    return (react.createElement(LayoutGroupContext/* LayoutGroupContext.Provider */.p.Provider, { value: memoizedContext }, children));
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimateSharedLayout.mjs





var id = 0;
var AnimateSharedLayout = function (_a) {
    var children = _a.children;
    react.useEffect(function () {
        (0,hey_listen_es.warning)(false, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
    }, []);
    return (react.createElement(LayoutGroup, { id: (0,use_constant/* useConstant */.h)(function () { return "asl-".concat(id++); }) }, children));
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
var MotionConfigContext = __webpack_require__(16014);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/filter-props.mjs
var filter_props = __webpack_require__(48041);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/MotionConfig/index.mjs







/**
 * `MotionConfig` is used to set configuration options for all children `motion` components.
 *
 * ```jsx
 * import { motion, MotionConfig } from "framer-motion"
 *
 * export function App() {
 *   return (
 *     <MotionConfig transition={{ type: "spring" }}>
 *       <motion.div animate={{ x: 100 }} />
 *     </MotionConfig>
 *   )
 * }
 * ```
 *
 * @public
 */
function MotionConfig(_a) {
    var children = _a.children, isValidProp = _a.isValidProp, config = (0,tslib_es6.__rest)(_a, ["children", "isValidProp"]);
    isValidProp && (0,filter_props/* loadExternalIsValidProp */.K)(isValidProp);
    /**
     * Inherit props from any parent MotionConfig components
     */
    config = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._)), config);
    /**
     * Don't allow isStatic to change between renders as it affects how many hooks
     * motion components fire.
     */
    config.isStatic = (0,use_constant/* useConstant */.h)(function () { return config.isStatic; });
    /**
     * Creating a new config context object will re-render every `motion` component
     * every time it renders. So we only want to create a new one sparingly.
     */
    var context = (0,react.useMemo)(function () { return config; }, [JSON.stringify(config.transition), config.transformPagePoint, config.reducedMotion]);
    return (react.createElement(MotionConfigContext/* MotionConfigContext.Provider */._.Provider, { value: context }, children));
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/LazyContext.mjs
var LazyContext = __webpack_require__(70398);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/definitions.mjs
var definitions = __webpack_require__(9442);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs






/**
 * Used in conjunction with the `m` component to reduce bundle size.
 *
 * `m` is a version of the `motion` component that only loads functionality
 * critical for the initial render.
 *
 * `LazyMotion` can then be used to either synchronously or asynchronously
 * load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, m, domAnimations } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={domAnimations}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion, m } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimations')}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 * ```
 *
 * @public
 */
function LazyMotion(_a) {
    var children = _a.children, features = _a.features, _b = _a.strict, strict = _b === void 0 ? false : _b;
    var _c = (0,tslib_es6.__read)((0,react.useState)(!isLazyBundle(features)), 2), setIsLoaded = _c[1];
    var loadedRenderer = (0,react.useRef)(undefined);
    /**
     * If this is a synchronous load, load features immediately
     */
    if (!isLazyBundle(features)) {
        var renderer = features.renderer, loadedFeatures = (0,tslib_es6.__rest)(features, ["renderer"]);
        loadedRenderer.current = renderer;
        (0,definitions/* loadFeatures */.K)(loadedFeatures);
    }
    (0,react.useEffect)(function () {
        if (isLazyBundle(features)) {
            features().then(function (_a) {
                var renderer = _a.renderer, loadedFeatures = (0,tslib_es6.__rest)(_a, ["renderer"]);
                (0,definitions/* loadFeatures */.K)(loadedFeatures);
                loadedRenderer.current = renderer;
                setIsLoaded(true);
            });
        }
    }, []);
    return (react.createElement(LazyContext/* LazyContext.Provider */.u.Provider, { value: { renderer: loadedRenderer.current, strict: strict } }, children));
}
function isLazyBundle(features) {
    return typeof features === "function";
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/ReorderContext.mjs


var ReorderContext = (0,react.createContext)(null);



// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/mix.mjs
var mix = __webpack_require__(72453);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/array.mjs
var array = __webpack_require__(10010);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/Reorder/utils/check-reorder.mjs



function checkReorder(order, value, offset, velocity) {
    if (!velocity)
        return order;
    var index = order.findIndex(function (item) { return item.value === value; });
    if (index === -1)
        return order;
    var nextOffset = velocity > 0 ? 1 : -1;
    var nextItem = order[index + nextOffset];
    if (!nextItem)
        return order;
    var item = order[index];
    var nextLayout = nextItem.layout;
    var nextItemCenter = (0,mix/* mix */.C)(nextLayout.min, nextLayout.max, 0.5);
    if ((nextOffset === 1 && item.layout.max + offset > nextItemCenter) ||
        (nextOffset === -1 && item.layout.min + offset < nextItemCenter)) {
        return (0,array/* moveItem */.uo)(order, index, index + nextOffset);
    }
    return order;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/Reorder/Group.mjs









function ReorderGroup(_a, externalRef) {
    var children = _a.children, _b = _a.as, as = _b === void 0 ? "ul" : _b, _c = _a.axis, axis = _c === void 0 ? "y" : _c, onReorder = _a.onReorder, values = _a.values, props = (0,tslib_es6.__rest)(_a, ["children", "as", "axis", "onReorder", "values"]);
    var Component = (0,use_constant/* useConstant */.h)(function () { return (0,motion/* motion */.E)(as); });
    var order = [];
    var isReordering = (0,react.useRef)(false);
    (0,hey_listen_es.invariant)(Boolean(values), "Reorder.Group must be provided a values prop");
    var context = {
        axis: axis,
        registerItem: function (value, layout) {
            /**
             * Ensure entries can't add themselves more than once
             */
            if (layout &&
                order.findIndex(function (entry) { return value === entry.value; }) === -1) {
                order.push({ value: value, layout: layout[axis] });
                order.sort(compareMin);
            }
        },
        updateOrder: function (id, offset, velocity) {
            if (isReordering.current)
                return;
            var newOrder = checkReorder(order, id, offset, velocity);
            if (order !== newOrder) {
                isReordering.current = true;
                onReorder(newOrder
                    .map(getValue)
                    .filter(function (value) { return values.indexOf(value) !== -1; }));
            }
        },
    };
    (0,react.useEffect)(function () {
        isReordering.current = false;
    });
    return (react.createElement(Component, (0,tslib_es6.__assign)({}, props, { ref: externalRef }),
        react.createElement(ReorderContext.Provider, { value: context }, children)));
}
var Group = (0,react.forwardRef)(ReorderGroup);
function getValue(item) {
    return item.value;
}
function compareMin(a, b) {
    return a.layout.min - b.layout.min;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/index.mjs
var es_value = __webpack_require__(33234);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,use_constant/* useConstant */.h)(function () { return (0,es_value/* motionValue */.B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).isStatic;
    if (isStatic) {
        var _a = (0,tslib_es6.__read)((0,react.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}



// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(59180);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6.__assign)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/utils/is-motion-value.mjs
var is_motion_value = __webpack_require__(40406);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(58868);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-on-change.mjs



function useOnChange(value, callback) {
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function () {
        if ((0,is_motion_value/* isMotionValue */.i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}



// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/framesync/dist/es/index.mjs + 2 modules
var es = __webpack_require__(89073);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-combine-values.mjs




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = useMotionValue(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    useMultiOnChange(values, function () { return es/* default.update */.ZP.update(updateValue, false, true); });
    return value;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6.__read)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return useCombineMotionValues(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/Reorder/Item.mjs











function useDefaultMotionValue(value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    return (0,is_motion_value/* isMotionValue */.i)(value) ? value : useMotionValue(defaultValue);
}
function ReorderItem(_a, externalRef) {
    var children = _a.children, style = _a.style, value = _a.value, _b = _a.as, as = _b === void 0 ? "li" : _b, onDrag = _a.onDrag, _c = _a.layout, layout = _c === void 0 ? true : _c, props = (0,tslib_es6.__rest)(_a, ["children", "style", "value", "as", "onDrag", "layout"]);
    var Component = (0,use_constant/* useConstant */.h)(function () { return (0,motion/* motion */.E)(as); });
    var context = (0,react.useContext)(ReorderContext);
    var point = {
        x: useDefaultMotionValue(style === null || style === void 0 ? void 0 : style.x),
        y: useDefaultMotionValue(style === null || style === void 0 ? void 0 : style.y),
    };
    var zIndex = useTransform([point.x, point.y], function (_a) {
        var _b = (0,tslib_es6.__read)(_a, 2), latestX = _b[0], latestY = _b[1];
        return latestX || latestY ? 1 : "unset";
    });
    var measuredLayout = (0,react.useRef)(null);
    (0,hey_listen_es.invariant)(Boolean(context), "Reorder.Item must be a child of Reorder.Group");
    var _d = context, axis = _d.axis, registerItem = _d.registerItem, updateOrder = _d.updateOrder;
    (0,react.useEffect)(function () {
        registerItem(value, measuredLayout.current);
    }, [context]);
    return (react.createElement(Component, (0,tslib_es6.__assign)({ drag: axis }, props, { dragSnapToOrigin: true, style: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, style), { x: point.x, y: point.y, zIndex: zIndex }), layout: layout, onDrag: function (event, gesturePoint) {
            var velocity = gesturePoint.velocity;
            velocity[axis] &&
                updateOrder(value, point[axis].get(), velocity[axis]);
            onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, gesturePoint);
        }, onLayoutMeasure: function (measured) {
            measuredLayout.current = measured;
        }, ref: externalRef }), children));
}
var Item = (0,react.forwardRef)(ReorderItem);



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/Reorder/index.mjs



var Reorder = {
    Group: Group,
    Item: Item,
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/animations.mjs
var animations = __webpack_require__(71903);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/gestures.mjs + 6 modules
var gestures = __webpack_require__(94453);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs + 4 modules
var create_visual_element = __webpack_require__(81891);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs





/**
 * @public
 */
var domAnimation = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ renderer: create_visual_element/* createDomVisualElement */.b }, animations/* animations */.s), gestures/* gestureAnimations */.E);



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/drag.mjs + 5 modules
var drag = __webpack_require__(83006);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/index.mjs + 3 modules
var layout = __webpack_require__(91283);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/projection/node/HTMLProjectionNode.mjs + 8 modules
var HTMLProjectionNode = __webpack_require__(87046);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-max.mjs






/**
 * @public
 */
var domMax = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, domAnimation), drag/* drag */.o), layout/* layoutFeatures */.U), { projectionNodeConstructor: HTMLProjectionNode/* HTMLProjectionNode */.u });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-template.mjs


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return useCombineMotionValues(values, buildValue);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.mjs
var resolve_motion_value = __webpack_require__(16399);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/animations/index.mjs + 6 modules
var es_animations = __webpack_require__(90612);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-spring.mjs








/**
 * Creates a `MotionValue` that, when `set`, will use a spring animation to animate to its new state.
 *
 * It can either work as a stand-alone `MotionValue` by initialising it with a value, or as a subscriber
 * to another `MotionValue`.
 *
 * @remarks
 *
 * ```jsx
 * const x = useSpring(0, { stiffness: 300 })
 * const y = useSpring(x, { damping: 10 })
 * ```
 *
 * @param inputValue - `MotionValue` or number. If provided a `MotionValue`, when the input `MotionValue` changes, the created `MotionValue` will spring towards that value.
 * @param springConfig - Configuration options for the spring.
 * @returns `MotionValue`
 *
 * @public
 */
function useSpring(source, config) {
    if (config === void 0) { config = {}; }
    var isStatic = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).isStatic;
    var activeSpringAnimation = (0,react.useRef)(null);
    var value = useMotionValue((0,is_motion_value/* isMotionValue */.i)(source) ? source.get() : source);
    (0,react.useMemo)(function () {
        return value.attach(function (v, set) {
            /**
             * A more hollistic approach to this might be to use isStatic to fix VisualElement animations
             * at that level, but this will work for now
             */
            if (isStatic)
                return set(v);
            if (activeSpringAnimation.current) {
                activeSpringAnimation.current.stop();
            }
            activeSpringAnimation.current = (0,es_animations/* animate */.j)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({ from: value.get(), to: v, velocity: value.getVelocity() }, config), { onUpdate: set }));
            return value.get();
        });
    }, [JSON.stringify(config)]);
    useOnChange(source, function (v) { return value.set(parseFloat(v)); });
    return value;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-velocity.mjs



/**
 * Creates a `MotionValue` that updates when the velocity of the provided `MotionValue` changes.
 *
 * ```javascript
 * const x = useMotionValue(0)
 * const xVelocity = useVelocity(x)
 * const xAcceleration = useVelocity(xVelocity)
 * ```
 *
 * @public
 */
function useVelocity(value) {
    var velocity = useMotionValue(value.getVelocity());
    (0,react.useEffect)(function () {
        return value.velocityUpdateSubscribers.add(function (newVelocity) {
            velocity.set(newVelocity);
        });
    }, [value]);
    return velocity;
}



// EXTERNAL MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/index.es.js + 6 modules
var index_es = __webpack_require__(25037);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs






var createScrollMotionValues = function () { return ({
    scrollX: (0,es_value/* motionValue */.B)(0),
    scrollY: (0,es_value/* motionValue */.B)(0),
    scrollXProgress: (0,es_value/* motionValue */.B)(0),
    scrollYProgress: (0,es_value/* motionValue */.B)(0),
}); };
function useScroll(_a) {
    if (_a === void 0) { _a = {}; }
    var container = _a.container, target = _a.target, options = (0,tslib_es6.__rest)(_a, ["container", "target"]);
    var values = (0,use_constant/* useConstant */.h)(createScrollMotionValues);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function () {
        return (0,index_es/* scroll */.A)(function (_a) {
            var x = _a.x, y = _a.y;
            values.scrollX.set(x.current);
            values.scrollXProgress.set(x.progress);
            values.scrollY.set(y.current);
            values.scrollYProgress.set(y.progress);
        }, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { container: (container === null || container === void 0 ? void 0 : container.current) || undefined, target: (target === null || target === void 0 ? void 0 : target.current) || undefined }));
    }, []);
    return values;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/warn-once.mjs
var warn_once = __webpack_require__(16034);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/scroll/use-element-scroll.mjs



function useElementScroll(ref) {
    (0,warn_once/* warnOnce */.O)(false, "useElementScroll is deprecated. Convert to useScroll({ container: ref }).");
    return useScroll({ container: ref });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/scroll/use-viewport-scroll.mjs



function useViewportScroll() {
    (0,warn_once/* warnOnce */.O)(false, "useViewportScroll is deprecated. Convert to useScroll().");
    return useScroll();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-animation-frame.mjs





var getCurrentTime = typeof performance !== "undefined"
    ? function () { return performance.now(); }
    : function () { return Date.now(); };
function useAnimationFrame(callback) {
    var initialTimestamp = (0,use_constant/* useConstant */.h)(getCurrentTime);
    var isStatic = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).isStatic;
    (0,react.useEffect)(function () {
        if (isStatic)
            return;
        var provideTimeSinceStart = function (_a) {
            var timestamp = _a.timestamp;
            callback(timestamp - initialTimestamp);
        };
        es/* default.update */.ZP.update(provideTimeSinceStart, true);
        return function () { return es/* cancelSync.update */.qY.update(provideTimeSinceStart); };
    }, [callback]);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-time.mjs



function useTime() {
    var time = useMotionValue(0);
    useAnimationFrame(function (t) { return time.set(t); });
    return time;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-reduced-motion.mjs
var use_reduced_motion = __webpack_require__(36240);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(77107);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(5759);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es.invariant)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimationControls() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}
var useAnimation = useAnimationControls;



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/animate.mjs
var animate = __webpack_require__(12064);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/wrap.mjs
const wrap = (min, max, v) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-cycle.mjs




/**
 * Cycles through a series of visual properties. Can be used to toggle between or cycle through animations. It works similar to `useState` in React. It is provided an initial array of possible states, and returns an array of two arguments.
 *
 * An index value can be passed to the returned `cycle` function to cycle to a specific index.
 *
 * ```jsx
 * import * as React from "react"
 * import { motion, useCycle } from "framer-motion"
 *
 * export const MyComponent = () => {
 *   const [x, cycleX] = useCycle(0, 50, 100)
 *
 *   return (
 *     <motion.div
 *       animate={{ x: x }}
 *       onTap={() => cycleX()}
 *      />
 *    )
 * }
 * ```
 *
 * @param items - items to cycle through
 * @returns [currentState, cycleState]
 *
 * @public
 */
function useCycle() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    var index = (0,react.useRef)(0);
    var _a = (0,tslib_es6.__read)((0,react.useState)(items[index.current]), 2), item = _a[0], setItem = _a[1];
    var runCycle = (0,react.useCallback)(function (next) {
        index.current =
            typeof next !== "number"
                ? wrap(0, items.length, index.current + 1)
                : next;
        setItem(items[index.current]);
    }, (0,tslib_es6.__spreadArray)([items.length], (0,tslib_es6.__read)(items), false));
    return [item, runCycle];
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
var valid_prop = __webpack_require__(59630);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs
var use_presence = __webpack_require__(15947);
// EXTERNAL MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js
var in_view_es = __webpack_require__(48688);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs




function useInView(ref, _a) {
    var _b = _a === void 0 ? {} : _a, root = _b.root, margin = _b.margin, amount = _b.amount, _c = _b.once, once = _c === void 0 ? false : _c;
    var _d = (0,tslib_es6.__read)((0,react.useState)(false), 2), isInView = _d[0], setInView = _d[1];
    (0,react.useEffect)(function () {
        var _a;
        if (!ref.current || (once && isInView))
            return;
        var onEnter = function () {
            setInView(true);
            return once ? undefined : function () { return setInView(false); };
        };
        var options = {
            root: (_a = root === null || root === void 0 ? void 0 : root.current) !== null && _a !== void 0 ? _a : undefined,
            margin: margin,
            amount: amount === "some" ? "any" : amount,
        };
        return (0,in_view_es/* inView */.j)(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/use-drag-controls.mjs


/**
 * Can manually trigger a drag gesture on one or more `drag`-enabled `motion` components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */
var DragControls = /** @class */ (function () {
    function DragControls() {
        this.componentControls = new Set();
    }
    /**
     * Subscribe a component's internal `VisualElementDragControls` to the user-facing API.
     *
     * @internal
     */
    DragControls.prototype.subscribe = function (controls) {
        var _this = this;
        this.componentControls.add(controls);
        return function () { return _this.componentControls.delete(controls); };
    };
    /**
     * Start a drag gesture on every `motion` component that has this set of drag controls
     * passed into it via the `dragControls` prop.
     *
     * ```jsx
     * dragControls.start(e, {
     *   snapToCursor: true
     * })
     * ```
     *
     * @param event - PointerEvent
     * @param options - Options
     *
     * @public
     */
    DragControls.prototype.start = function (event, options) {
        this.componentControls.forEach(function (controls) {
            controls.start(event.nativeEvent || event, options);
        });
    };
    return DragControls;
}());
var createDragControls = function () { return new DragControls(); };
/**
 * Usually, dragging is initiated by pressing down on a `motion` component with a `drag` prop
 * and moving it. For some use-cases, for instance clicking at an arbitrary point on a video scrubber, we
 * might want to initiate that dragging from a different component than the draggable one.
 *
 * By creating a `dragControls` using the `useDragControls` hook, we can pass this into
 * the draggable component's `dragControls` prop. It exposes a `start` method
 * that can start dragging from pointer events on other components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */
function useDragControls() {
    return (0,use_constant/* useConstant */.h)(createDragControls);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/events/use-dom-event.mjs
var use_dom_event = __webpack_require__(51756);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/index.mjs + 8 modules
var es_motion = __webpack_require__(97641);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/index.mjs + 2 modules
var render = __webpack_require__(20404);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/projection/styles/scale-correction.mjs
var scale_correction = __webpack_require__(64561);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/projection/use-instant-layout-transition.mjs


function useInstantLayoutTransition() {
    return startTransition;
}
function startTransition(cb) {
    if (!HTMLProjectionNode/* rootProjectionNode.current */.J.current)
        return;
    HTMLProjectionNode/* rootProjectionNode.current.isUpdating */.J.current.isUpdating = false;
    HTMLProjectionNode/* rootProjectionNode.current.blockUpdate */.J.current.blockUpdate();
    cb === null || cb === void 0 ? void 0 : cb();
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-instant-transition-state.mjs
var use_instant_transition_state = __webpack_require__(78627);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-instant-transition.mjs







function useInstantTransition() {
    var _a = (0,tslib_es6.__read)((0,use_force_update/* useForceUpdate */.N)(), 2), forceUpdate = _a[0], forcedRenderCount = _a[1];
    var startInstantLayoutTransition = useInstantLayoutTransition();
    (0,react.useEffect)(function () {
        /**
         * Unblock after two animation frames, otherwise this will unblock too soon.
         */
        es/* default.postRender */.ZP.postRender(function () {
            return es/* default.postRender */.ZP.postRender(function () { return (use_instant_transition_state/* instantAnimationState.current */.c.current = false); });
        });
    }, [forcedRenderCount]);
    return function (callback) {
        startInstantLayoutTransition(function () {
            use_instant_transition_state/* instantAnimationState.current */.c.current = true;
            forceUpdate();
            callback();
        });
    };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/projection/use-reset-projection.mjs



function useResetProjection() {
    var reset = react.useCallback(function () {
        var root = HTMLProjectionNode/* rootProjectionNode.current */.J.current;
        if (!root)
            return;
        root.resetTree();
    }, []);
    return reset;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/MotionContext/index.mjs
var MotionContext = __webpack_require__(24451);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.mjs
var PresenceContext = __webpack_require__(240);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/SwitchLayoutGroupContext.mjs
var SwitchLayoutGroupContext = __webpack_require__(41705);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/flat-tree.mjs + 1 modules
var flat_tree = __webpack_require__(31419);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
var use_visual_state = __webpack_require__(45180);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/projection/geometry/models.mjs
var models = __webpack_require__(61512);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/use-animated-state.mjs









var createObject = function () { return ({}); };
var stateVisualElement = (0,render/* visualElement */.q)({
    build: function () { },
    measureViewportBox: models/* createBox */.dO,
    resetTransform: function () { },
    restoreTransform: function () { },
    removeValueFromRenderState: function () { },
    render: function () { },
    scrapeMotionValuesFromProps: createObject,
    readValueFromInstance: function (_state, key, options) {
        return options.initialState[key] || 0;
    },
    makeTargetAnimatable: function (element, _a) {
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0,tslib_es6.__rest)(_a, ["transition", "transitionEnd"]);
        var origin = (0,setters/* getOrigin */.P$)(target, transition || {}, element);
        (0,setters/* checkTargetForNewValues */.GJ)(element, target, origin);
        return (0,tslib_es6.__assign)({ transition: transition, transitionEnd: transitionEnd }, target);
    },
});
var useVisualState = (0,use_visual_state/* makeUseVisualState */.t)({
    scrapeMotionValuesFromProps: createObject,
    createRenderState: createObject,
});
/**
 * This is not an officially supported API and may be removed
 * on any version.
 */
function useAnimatedState(initialState) {
    var _a = (0,tslib_es6.__read)((0,react.useState)(initialState), 2), animationState = _a[0], setAnimationState = _a[1];
    var visualState = useVisualState({}, false);
    var element = (0,use_constant/* useConstant */.h)(function () {
        return stateVisualElement({ props: {}, visualState: visualState }, { initialState: initialState });
    });
    (0,react.useEffect)(function () {
        element.mount({});
        return element.unmount;
    }, [element]);
    (0,react.useEffect)(function () {
        element.setProps({
            onUpdate: function (v) {
                setAnimationState((0,tslib_es6.__assign)({}, v));
            },
        });
    }, [setAnimationState, element]);
    var startAnimation = (0,use_constant/* useConstant */.h)(function () { return function (animationDefinition) {
        return (0,animation/* animateVisualElement */.d5)(element, animationDefinition);
    }; });
    return [animationState, startAnimation];
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-inverted-scale.mjs





// Keep things reasonable and avoid scale: Infinity. In practise we might need
// to add another value, opacity, that could interpolate scaleX/Y [0,0.01] => [0,1]
// to simply hide content at unreasonable scales.
var maxScale = 100000;
var invertScale = function (scale) {
    return scale > 0.001 ? 1 / scale : maxScale;
};
var hasWarned = false;
/**
 * Returns a `MotionValue` each for `scaleX` and `scaleY` that update with the inverse
 * of their respective parent scales.
 *
 * This is useful for undoing the distortion of content when scaling a parent component.
 *
 * By default, `useInvertedScale` will automatically fetch `scaleX` and `scaleY` from the nearest parent.
 * By passing other `MotionValue`s in as `useInvertedScale({ scaleX, scaleY })`, it will invert the output
 * of those instead.
 *
 * ```jsx
 * const MyComponent = () => {
 *   const { scaleX, scaleY } = useInvertedScale()
 *   return <motion.div style={{ scaleX, scaleY }} />
 * }
 * ```
 *
 * @deprecated
 */
function useInvertedScale(scale) {
    var parentScaleX = useMotionValue(1);
    var parentScaleY = useMotionValue(1);
    var visualElement = (0,MotionContext/* useVisualElementContext */.B)();
    (0,hey_listen_es.invariant)(!!(scale || visualElement), "If no scale values are provided, useInvertedScale must be used within a child of another motion component.");
    (0,hey_listen_es.warning)(hasWarned, "useInvertedScale is deprecated and will be removed in 3.0. Use the layout prop instead.");
    hasWarned = true;
    if (scale) {
        parentScaleX = scale.scaleX || parentScaleX;
        parentScaleY = scale.scaleY || parentScaleY;
    }
    else if (visualElement) {
        parentScaleX = visualElement.getValue("scaleX", 1);
        parentScaleY = visualElement.getValue("scaleY", 1);
    }
    var scaleX = useTransform(parentScaleX, invertScale);
    var scaleY = useTransform(parentScaleY, invertScale);
    return { scaleX: scaleX, scaleY: scaleY };
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/types.mjs
var types = __webpack_require__(3233);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/projection/geometry/delta-calc.mjs
var delta_calc = __webpack_require__(16645);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/utils/lock.mjs
var lock = __webpack_require__(37544);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/events/use-pointer-event.mjs + 1 modules
var use_pointer_event = __webpack_require__(70737);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/events/event-info.mjs
var event_info = __webpack_require__(28148);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/is-browser.mjs
var is_browser = __webpack_require__(11741);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.mjs
var use_unmount_effect = __webpack_require__(65411);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/index.mjs


































































/***/ })

}]);